export enum ContentType {
  Skills = 'skills',
  Training = 'training',
  Competence = 'competence',
  Task = 'task',
  Goal = 'goal',
  Note = 'note',
  Learning = 'learning',
  Survey = 'survey',
  Form = 'form',
}

export type ContentStatus = 'published' | 'draft' | 'unpublished'

export interface ContentDataPost {
  content_type: ContentType
  is_draft: boolean
  published_at?: string | null
  anonymized: boolean
  minimum_score: number
  duration_minutes: number
  thumbnail: File | null
  title: string
  description: string
  topic: string
  url?: string | null
}

export interface ContentDataResponse {
  id: string
  status: string
  created_at: string
  updated_at: string
  content_type: ContentType
  is_draft: boolean
  published_at: string
  anonymized: boolean
  minimum_score: number
  duration_minutes: number
  thumbnail: { file: File; type: string }
  title: string
  description: string
  topic: string
}
